<template>
    <div class="form-group ">
        <label :for="name" v-if="!hideLabel">{{label}}</label>
        <input v-validate="validate"
               :value="value"
               @input="inputValue"
               :id="name"
               type="color"
               :data-vv-as="label"

               :placeholder="placeholder"
               class="form-control"
               :class="{'is-invalid':errors.has(name)}"
               :name="name">
        <div v-if="errors.has(name)" class="invalid-feedback">
            {{errors.first(name)}}
        </div>
    </div>
</template>

<script>
    import mixinField from '../../mixins/mixinField';

    export default {
        mixins: [mixinField],
        name: "FieldColor",
        data() {
            return {
                rules:""
            }
        },

        }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/fields/FieldColor.vue